import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const STAGE = {
  valutazione: "Valutazione",
  decisione_presa: "Decisione presa",
  piano_azione: "Piano d'azione",
  consulenza_richiesta: "Consulenza richiesta",
  consulenza_assegnata: "Consulenza assegnata",
};
const PROV = { tuo_link: "Il tuo link", vg: "ValutaGenio", altro_pa: "Altro professionista" };
const WHO = { tu: "Tu", altro: "Altro PA", nessuno: "—" };
const CONSENT = { non_richiesto: "Non ancora richiesto", attivo: "Attivo", revocato: "Revocato" };

function StateBanner({ st }) {
  if (!st || ["active", "admin", "founder"].includes(st.status)) return null;
  const grace = st.status === "grace";
  const until = st.grace_until ? new Date(st.grace_until).toLocaleDateString("it-IT") : "";
  return (
    <div data-testid="v3-leads-pa-state"
         className={`p-3 rounded-lg text-sm ${grace ? "bg-amber-50 text-amber-900 border border-amber-200" : "bg-red-50 text-red-900 border border-red-200"}`}>
      {grace
        ? `Pagamento non riuscito: regolarizza entro il ${until} per continuare ad acquisire nuovi casi.`
        : "Abbonamento non attivo: il tuo link non acquisisce nuovi casi e la gestione dei casi è sospesa. I casi già attribuiti restano tuoi."}
    </div>
  );
}

export function V3Leads() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/agent/v3-cases").then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0 }));
  }, []);
  if (!data) return null;
  return (
    <div className="space-y-3" data-testid="v3-leads">
      <div>
        <h2 className="text-lg font-semibold text-[#0A0A0A]">Casi ValutaGenio V3</h2>
        <p className="text-gray-500 text-sm" data-testid="v3-leads-total">
          {data.total} {data.total === 1 ? "caso" : "casi"} · i dati del proprietario sono visibili solo dopo il suo consenso e l'assegnazione
        </p>
      </div>
      <StateBanner st={data.pa_state} />
      <div className="vg-card overflow-x-auto">
        {data.items.length === 0 ? (
          <p className="p-6 text-gray-500 text-sm" data-testid="v3-leads-empty">
            Nessun caso V3 per ora. Condividi il tuo link: i casi aperti da chi lo usa compaiono qui.
          </p>
        ) : (
          <table className="w-full text-sm" data-testid="v3-leads-table">
            <thead className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
              <tr>
                {["Aperto", "Provenienza", "Referente", "Assegnatario", "Consenso", "Stato", ""].map((h) => (
                  <th key={h} className="text-left px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.items.map((c) => (
                <tr key={c.case_id} className="border-t border-gray-100" data-testid={`v3-lead-row-${c.case_id}`}>
                  <td className="px-4 py-3 text-gray-500">{c.created_at ? new Date(c.created_at).toLocaleDateString("it-IT") : "—"}</td>
                  <td className="px-4 py-3" data-testid={`v3-lead-prov-${c.case_id}`}>{PROV[c.provenienza]}</td>
                  <td className="px-4 py-3">{WHO[c.referente]}</td>
                  <td className="px-4 py-3" data-testid={`v3-lead-assignee-${c.case_id}`}>{WHO[c.assegnatario]}</td>
                  <td className="px-4 py-3" data-testid={`v3-lead-consent-${c.case_id}`}>{CONSENT[c.consenso]}</td>
                  <td className="px-4 py-3" data-testid={`v3-lead-stage-${c.case_id}`}>{STAGE[c.stato]}</td>
                  <td className="px-4 py-3">
                    {c.workspace_available && (
                      <Link to={`/vg2/pa/cases/${c.case_id}`} className="text-[#B40101] font-semibold hover:underline"
                            data-testid={`v3-lead-open-${c.case_id}`}>Apri caso →</Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
